import axios from "@/config/axios";

// initial state
const initialState = () => {
  return {
    entityRelationships: [],
    multipleEntityRelationships: {},
    currentEntityRelationships: [],
    currentEntityNestedRelationships: [],
    entityRelationshipAddStatus: false,
    entityRelationshipsAddStatus: false,
    entityRelationshipUpdateStatus: false,
    entityRelationshipDeleteStatus: false,
    entityRelationshipDataAssignStatus: false,
    entityRelationshipDataDetachStatus: false,
    parentEntityRelationshipData: {

    },
    allExistedEntityRelationships: [],
    parentEntityNestedRelationshipData: [],
    entityNestedRelationships: [],
    entityRelationshipDataAssignFeildsDataStatus: false,
    entityAllRelationshipData: [],
    subentityRelationships: []
  };
};

const state = initialState();

const getters = {
  getEntityRelationships: state => state.entityRelationships,
  getMultipleEntityRelationships: state => state.multipleEntityRelationships,
  getEntityNestedRelationships: state => state.entityNestedRelationships,
  getCurrentEntityRelationships: state => state.currentEntityRelationships,
  getCurrentEntityNestedRelationships: state => state.currentEntityNestedRelationships,

  getEntityRelationshipAddStatus: state => state.entityRelationshipAddStatus,
  getEntityRelationshipsAddStatus: state => state.entityRelationshipsAddStatus,
  getEntityRelationshipUpdateStatus: state => state.entityRelationshipUpdateStatus,
  getEntityRelationshipDeleteStatus: state => state.entityRelationshipDeleteStatus,
  getEntityRelationshipDataAssignStatus: state => state.entityRelationshipDataAssignStatus,
  getEntityRelationshipDataDetachStatus: state => state.
    entityRelationshipDataDetachStatus,
  getParentEntityRelatiponshipData: state => state.parentEntityRelationshipData,

  getAllExistedEntityRelationships: state => state.allExistedEntityRelationships,
  getEntityRelationshipDataAssignFeildsDataStatus: state => state.entityRelationshipDataAssignFeildsDataStatus,
  getParentEntityNestedRelationshipData: state => state.parentEntityNestedRelationshipData,
  getEntityAllRelationshipData: state => state.entityAllRelationshipData,
  getSubentityRelationships: state => state.subentityRelationships
};

const mutations = {

  setEntityRelationships: (state, data) => {
    state.entityRelationships = data
  },
  setMultipleEntityRelationships: (state, data) => {
    state.multipleEntityRelationships = data
  },
  setSubEntityRelationships: (state, data) => {
    state.subentityRelationships = data
  },
  setEntityNestedRelationships: (state, data) => {
    state.entityNestedRelationships = data
  },

  setEntityRelationshipAddStatus: (state, data) => {
    state.entityRelationshipAddStatus = data
  },
  setEntityRelationshipsAddStatus: (state, data) => {
    state.entityRelationshipsAddStatus = data
  },
  setEntityRelationshipUpdateStatus: (state, data) => {
    state.entityRelationshipUpdateStatus = data
  },

  setEntityRelationshipDeleteStatus: (state, data) => {
    state.entityRelationshipDeleteStatus = data
  },

  setCurrentEntityRelationships: (state, data) => {
    state.currentEntityRelationships = data
  },
  setCurrentEntityNestedRelationships: (state, data) => {
    state.currentEntityNestedRelationships = data
  },

  setEntityRelationshipDataAssignStatus: (state, data) => {
    state.entityRelationshipDataAssignStatus = data
  },

  setEntityRelationshipDataAssignFeildsDataStatus: (state, data) => {
    state.entityRelationshipDataAssignFeildsDataStatus = data
  },


  setEntityRelationshipDataDetachStatus: (state, data) => {
    state.entityRelationshipDataDetachStatus = data
  },

  setParentEntityRelationshipData: (state, data) => {
    state.parentEntityRelationshipData = data
  },

  setParentEntityNestedRelationshipData: (state, data) => {
    state.parentEntityNestedRelationshipData = data
  },

  setAllExistedEntityRelationships: (state, data) => {
    state.allExistedEntityRelationships = data
  },
  setEntityAllRelationshipData: (state, data) => {
    state.entityAllRelationshipData = data
  },
  resetData: state => {
    const initial = initialState();
    Object.keys(initial).forEach(key => {
      state[key] = initial[key];
    });
  },
};

const actions = {
  reset: function (context) {
    context.commit("entityRelationships/resetData", null, {
      root: true
    });
  },


  updateCurrentEntityRelationships: ({
    commit
  }, params) => {
    try {
      commit('setCurrentEntityRelationships', params);
    }
    catch (err) {
      console.error(err)
    }
  },

  updateCurrentEntityNestedRelationships: ({
    commit
  }, params) => {
    try {
      commit('setCurrentEntityNestedRelationships', params);
    }
    catch (err) {
      console.error(err)
    }
  },

  fetchSubEntityRelationships: async ({
    commit,
    dispatch
  }, params) => {
    try {
      let URL = `/entities/${params.entity_id}/relationships`;
      commit('setSubEntityRelationships', []);
      let res = await axios.get(URL, { params });
      commit('setSubEntityRelationships', res.data.data);

    } catch (err) {
      console.log(err)
      commit('setSubEntityRelationships', []);
      await dispatch('errors/errorResponse', err.response, {
        root: true
      });
    }
  },

  fetchEntityRelationships: async ({
    commit,
    dispatch
  }, params) => {
    try {
      let URL = `/entities/${params.entity_id}/relationships`;
      commit('setEntityRelationships', []);
      let res = await axios.get(URL, { params });
      commit('setEntityRelationships', res.data.data);

    } catch (err) {
      console.log(err)
      commit('setEntityRelationships', []);
      await dispatch('errors/errorResponse', err.response, {
        root: true
      });
    }
  },
  fetchMultipleEntityRelationships: async({
    commit, dispatch
  },params) => {
    try{
      commit("setMultipleEntityRelationships",{});
    let res = await axios.post(`/entities/relationships`,params)
    commit("setMultipleEntityRelationships", res.data.data)
    }
    catch(err){
      console.log(err)
      commit('setMultipleEntityRelationships', {});
      await dispatch('errors/errorResponse', err.response, {
        root: true
      });
    }
    
  },

  fetchEntityNestedRelationships: async ({
    commit,
    dispatch
  }, params) => {
    try {
      let URL = `/entities/${params.entity_id}/nested-relationships`;
      commit('setEntityNestedRelationships', []);
      let fetchAll = params.fetchAll ? true : false
      URL = URL + `?fetchAll=${fetchAll}`
      let res = await axios.get(URL);
      commit('setEntityNestedRelationships', res.data.data);

    } catch (err) {
      console.log(err)
      commit('setEntityNestedRelationships', []);
      await dispatch('errors/errorResponse', err.response, {
        root: true
      });
    }
  },




  addEntityRelationship: async ({
    commit,
    dispatch
  }, params) => {
    try {

      let URL = `/entities/${params.parent_entity_id}/relationships`;

      commit('setEntityRelationshipAddStatus', false);

      await axios.post(URL, params);

      commit('setEntityRelationshipAddStatus', true);

    } catch (err) {

      console.log(err)
      commit('setEntityRelationshipAddStatus', false);
      await dispatch('errors/errorResponse', err.response, {
        root: true
      });
    }
  },

  addEntityRelationships: async ({
    commit
  }, params) => {
    try {
      let URL = `/entities/${params.parent_entity_id}/addRelationships`;

      commit('setEntityRelationshipsAddStatus', false);

      await axios.post(URL, params);

      commit('setEntityRelationshipsAddStatus', true);
    }
    catch (err) {
      console.log(err)
    }
  },



  updateEntityRelationship: async ({
    commit,
    dispatch
  }, params) => {
    try {

      let URL = `/entities/${params.entity_id}/relationships`;

      commit('setEntityRelationshipUpdateStatus', false);
      await axios.post(URL, params);

      commit('setEntityRelationshipUpdateStatus', true);
    } catch (err) {
      commit('setEntityRelationshipUpdateStatus', false);
      await dispatch('errors/errorResponse', err.response, {
        root: true
      });
    }
  },



  deleteEntityRelationship: async ({
    commit,
    dispatch
  }, params) => {
    try {

      let URL = `/entities/${params.parent_entity_id}/relationships/${params.entity_relationship_id}`;

      commit('setEntityRelationshipDeleteStatus', false);

      await axios.delete(URL, params);

      commit('setEntityRelationshipDeleteStatus', true);

    } catch (err) {
      commit('setEntityRelationshipDeleteStatus', false);
      await dispatch('errors/errorResponse', err.response, {
        root: true
      });
    }
  },

  assignEntityRelationshipData: async ({
    commit,
    dispatch
  }, params) => {
    try {

      let URL = `/entities/${params.parent_entity_id}/relationships-data/assign`;

      commit('setEntityRelationshipDataAssignStatus', false);

      await axios.post(URL, params);

      commit('setEntityRelationshipDataAssignStatus', true);

    } catch (err) {

      console.log(err)
      commit('setEntityRelationshipDataAssignStatus', false);
      await dispatch('errors/errorResponse', err.response, {
        root: true
      });
    }
  },

  assignFieldsEntityRelationshipData: async ({
    commit,
    dispatch
  }, params) => {
    try {

      let URL = `/entities/${params[0].parent_entity_id}/relationships-data/assign-fields-data`;

      commit('setEntityRelationshipDataAssignFeildsDataStatus', false);

      await axios.post(URL, params);

      commit('setEntityRelationshipDataAssignFeildsDataStatus', true);

    } catch (err) {

      console.log(err)
      commit('setEntityRelationshipDataAssignFeildsDataStatus', false);
      await dispatch('errors/errorResponse', err.response, {
        root: true
      });
    }
  },

  detachEntityRelationshipData: async ({
    commit,
    dispatch
  }, params) => {
    try {

      let URL = `/entities/${params.parent_entity_id}/relationships-data/detach`;

      commit('setEntityRelationshipDataDetachStatus', false);
      await axios.post(URL, params);
      commit('setEntityRelationshipDataDetachStatus', true);

    } catch (err) {

      console.log(err)
      commit('setEntityRelationshipDataDetachStatus', false);
      await dispatch('errors/errorResponse', err.response, {
        root: true
      });
    }
  },

  fetchParentEntityRelationshipData: async ({
    commit,
    dispatch
  }, params) => {
    try {

      let URL = `/entities/${params.parent_entity_id}/relationships-data/${params.parent_entity_data_id}/${params.child_entity_id}`;

      commit('setParentEntityRelationshipData', {});

      let response = await axios.get(URL, params);

      commit('setParentEntityRelationshipData', response.data.data);

    } catch (err) {

      console.log(err)
      commit('setParentEntityRelationshipData', {});
      await dispatch('errors/errorResponse', err.response, {
        root: true
      });
    }
  },
  fetchEntityAllRelationshipData: async ({
    commit,
    dispatch
  }, params) => {
    try {

      let URL = `/entities/${params.parent_entity_id}/relationships-data/${params.parent_entity_data_id}`;

      commit('setEntityAllRelationshipData', []);

      let response = await axios.get(URL, params);

      commit('setEntityAllRelationshipData', response.data.data);

    } catch (err) {

      console.log(err)
      commit('setEntityAllRelationshipData', []);
      await dispatch('errors/errorResponse', err.response, {
        root: true
      });
    }
  },
  fetchParentEntityNestedRelationshipData: async ({
    commit,
    dispatch
  }, params) => {
    try {

      let URL = `/entities/${params.parent_entity_id}/relationships-data/${params.parent_entity_data_id}/${params.child_entity_id}/${params.nested_child_entity_id}`;

      commit('setParentEntityNestedRelationshipData', {});

      let response = await axios.get(URL, params);

      commit('setParentEntityNestedRelationshipData', response.data.data);

    } catch (err) {

      console.log(err)
      commit('setParentEntityNestedRelationshipData', {});
      await dispatch('errors/errorResponse', err.response, {
        root: true
      });
    }
  },
  fetchAllExistedRelationships: async ({
    commit,
    dispatch
  }, params) => {
    try {
      commit('setAllExistedEntityRelationships', [])
      let response = await axios.post('/entities/entity-relationships/existed', params)

      commit('setAllExistedEntityRelationships', response.data.data)

    }
    catch (err) {

      commit('setAllExistedEntityRelationships', [])

      await dispatch('errors/errorResponse', err.response, {
        root: true
      });
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};